import { useImperativeHandle } from 'react'
import { useForm } from 'react-hook-form'

const usePwdForm = function (ref) {
  const {
    watch,
    control,
    register,
    formState: { errors },
    formState,
    getValues,
    trigger,
    clearErrors,
    reset,
    setError,
  } = useForm()

  if (ref) {
    useImperativeHandle(ref, () => ({
      getValues,
      trigger,
    }))
  }

  return {
    reset,
    watch,
    control,
    register,
    formState,
    errors,
    clearErrors,
    setError,
  }
}

export default usePwdForm
